<template>
<BaseTemplate :currentUser="currentUser" :isTop="true">
  <div class="corporationList">
    <div v-for="corporation in corporationList" :key="corporation.id">
      <CorporationRow :corporation="corporation"  @show-modal="showModal = true"></CorporationRow>
    </div>
  </div>
  <CommonOverlay v-if="showModal" class="overlay" @handleOverlayClick="showModal = false">
      <CommonModal class="modal">
        <div class="modal-inner">
          {{ t('まだ販売されている商品がありません') }}
        </div>
      </CommonModal>
    </CommonOverlay>
</BaseTemplate>
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import CorporationRow from '@/components/molecules/CorporationRow.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';

export default {
  name: 'Store',

  components: {
    BaseTemplate,
    CorporationRow,
    CommonOverlay,
    CommonModal,
  },

  mixins: [t],

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    ...mapGetters({
      corporationList: 'corporation/list',
    }),
  },

  created() {
    this.$store.dispatch('corporation/setList');
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped>
.corporationList{
  display: grid;
  grid-template-columns: repeat(2, 1fr); // PCでは2列
  gap: 20px;
  padding: 20px;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr; // スマホでは1列
    gap: 0;
  }
}
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    width: auto;
    padding: 20px;
    width: 600px;
    max-height: 100%;
    overflow-y: auto;
    .modal-inner{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
